import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Col, Placeholder, Table, Form, FormGroup, ControlLabel } from 'rsuite'

export default function BackgroundOfElderlyView({ schema }) {
  const { Graph } = Placeholder
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const [elderlyCountTypeList, setElderlyCountTypeList] = useState([])
  const [elderlyHealthList, setElderlyHealthList] = useState([])
  const [elderlySocialList, setElderlySocialList] = useState([])

  useEffect(() => {
    // let countTypeList = getCountTypeList()
    // let healthList = getHealthList()

    setElderlyHealthList(getCountTypeList())
    setElderlyCountTypeList(getHealthList())
    setElderlySocialList(getSocialList())
  }, [schema])

  const getCountTypeList = () => {
    let countTypeList = []

    countTypeList.push({ name: schema.elderlyCountText, text: true })
    countTypeList.push({ name: schema.allPeople.label, value: schema.allPeople.value })
    countTypeList.push({ name: schema.elderlyPeople.label, value: schema.elderlyPeople.value })
    countTypeList.push({ name: schema.elderlyTypeText, text: true })
    countTypeList.push({
      name: schema.elderlySocialGroup.label,
      value: schema.elderlySocialGroup.value,
    })
    countTypeList.push({
      name: schema.elderlyHomeGroup.label,
      value: schema.elderlyHomeGroup.value,
    })
    countTypeList.push({
      name: schema.elderlyBedStickGroup.label,
      value: schema.elderlyBedStickGroup.value,
    })

    return countTypeList
  }

  const getHealthList = () => {
    let healthList = []
    healthList.push({
      name: schema.elderlyNoHealthProblem.label,
      value: schema.elderlyNoHealthProblem.value,
      main: true,
    })
    healthList.push({
      name: schema.elderlyHealthProblem.label,
      value: schema.elderlyHealthProblem.value,
      main: true,
    })
    healthList.push({
      name: schema.elderlyHypertension.label,
      value: schema.elderlyHypertension.value,
    })
    healthList.push({ name: schema.elderlyDiabetes.label, value: schema.elderlyDiabetes.value })
    healthList.push({
      name: schema.elderlyDegenerative.label,
      value: schema.elderlyDegenerative.value,
    })
    healthList.push({
      name: schema.elderlyEmphysema.label,
      value: schema.elderlyEmphysema.value,
    })
    healthList.push({
      name: schema.elderlyCoronaryHeartDisease.label,
      value: schema.elderlyCoronaryHeartDisease.value,
    })
    healthList.push({
      name: schema.elderlyParalysis.label,
      value: schema.elderlyParalysis.value,
    })
    healthList.push({
      name: schema.elderlyDepression.label,
      value: schema.elderlyDepression.value,
    })

    schema.elderlyOtherDisease.value.map((item, index) => {
      healthList.push({
        name: '2.' + (index + 8) + ' ' + item.name,
        value: item.amount,
      })
    })

    healthList.push({
      name: schema.elderlyHealthPromotion.label,
      value: schema.elderlyHealthPromotion.value,
      main: true,
    })
    healthList.push({
      name: schema.elderlyHealthExercise.label,
      value: schema.elderlyHealthExercise.value,
    })
    healthList.push({
      name: schema.elderlyHealthRightFood.label,
      value: schema.elderlyHealthRightFood.value,
    })

    return healthList
  }

  const getSocialList = () => {
    let socialList = []

    socialList.push({
      name: schema.elderlySocialCount.label,
      value: schema.elderlySocialCount.value,
    })
    socialList.push({
      name: schema.elderlySocialJoinActivity.label,
      value: schema.elderlySocialJoinActivity.value,
    })
    socialList.push({
      name: schema.elderlySocialAccident.label,
      value: schema.elderlySocialAccident.value,
    })

    return socialList
  }

  const paragraph = <>&nbsp; &nbsp; &nbsp;</>

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            <p>
              {paragraph}
              {schema.activity.label
                .replace('{village}', schema.villageInfo.village)
                .replace('{subDistrict}', schema.villageInfo.subDistrict)
                .replace('{district}', schema.villageInfo.district)
                .replace('{province}', schema.villageInfo.province)}
              {schema.activity.options.map((item) => {
                if (item.value == schema.activity.value) {
                  return item.label
                }
              })}
              {schema.activity.value == 'Y' && (
                <>
                  {schema.activityYear.label} {schema.activityYear.value}{' '}
                  {schema.activityMember.preLabel} {schema.activityMember.value}{' '}
                  {schema.activityMember.postLabel} {schema.activityLeader.preLabel}{' '}
                  {schema.activityLeader.value} {schema.activityLeader.postLabel}{' '}
                </>
              )}
            </p>
          </Row>
          <Row style={styles.marginTop10}>
            {schema.activityList.value && (
              <>
                <p>
                  {paragraph}
                  {schema.activityList.label}
                </p>
                {schema.activityList.value.map((item, index) => {
                  return (
                    <>
                      <p style={{ marginLeft: 10 }}>
                        {schema.activityForm.activity.label + (index + 1)}{' '}
                        <b>{item.activityName}</b>
                      </p>

                      {item.activityResult ? (
                        <p style={{ marginLeft: 10 }}>
                          {schema.activityForm.result.label} {item.activityResult}
                        </p>
                      ) : (
                        <>
                          <p style={{ marginLeft: 10 }}>{schema.activityForm.result.label}</p>

                          <div style={{ marginLeft: 20 }}>
                            <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
                            <Graph height={9} />
                            <Graph height={9} />
                          </div>
                        </>
                      )}
                    </>
                  )
                })}
              </>
            )}
          </Row>
          <Row style={styles.marginTop_2em}>
            <p>
              {paragraph}
              {schema.activityProblem.label}
            </p>
            {schema.activityProblem.value ? (
              // <p style={{ marginLeft: 10 }}>{schema.activityForm.value}</p>
              <div dangerouslySetInnerHTML={{ __html: schema.activityProblem.value }} />
            ) : (
              <div style={{ marginLeft: 10 }}>
                <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          <Row style={styles.marginTop_2em}>
            <Col>
              {paragraph}
              {schema.elderlyInfoText
                .replace('{village}', schema.villageInfo.village)
                .replace('{subDistrict}', schema.villageInfo.subDistrict)
                .replace('{district}', schema.villageInfo.district)
                .replace('{province}', schema.villageInfo.province)}
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: 10 }}>
              <b>{schema.elderlyCountTypeText}</b>
              <Table
                style={{ marginTop: 10 }}
                bordered
                data={elderlyCountTypeList}
                cellBordered
                autoHeight
                onRowClick={(data) => {
                  console.log(data)
                }}
              >
                <Column width={100} flexGrow={1} colSpan={2}>
                  <HeaderCell align="center">หัวข้อ</HeaderCell>
                  {/* <Cell dataKey="topic" /> */}
                  <Cell>
                    {(rowData) => {
                      if (rowData.text) {
                        return (
                          <span>
                            <b>{rowData.name}</b>
                          </span>
                        )
                      } else return <span>{rowData.name}</span>
                    }}
                  </Cell>
                </Column>

                <Column width={160} align="center">
                  <HeaderCell>จำนวนคน</HeaderCell>
                  <Cell dataKey="value" />
                </Column>
              </Table>
              <p>
                ( {schema.elderlyTypeSourceInfo.label} <b>{schema.elderlyTypeSourceInfo.value}</b>
                {schema.elderlyTypeSourceMonth.label}{' '}
                <b>
                  {schema.elderlyTypeSourceMonth.options.map((item) => {
                    if (item.value == schema.elderlyTypeSourceMonth.value) {
                      return item.label
                    }
                  })}
                </b>{' '}
                {schema.elderlyTypeSourceInfoYear.label}{' '}
                <b>{schema.elderlyTypeSourceInfoYear.value}</b> )
              </p>
            </Col>
          </Row>

          <Row>
            <Col style={{ marginTop: 10 }}>
              <b>{schema.elderlyHealthText}</b>
              <Table
                style={{ marginTop: 10 }}
                bordered
                data={elderlyHealthList}
                cellBordered
                autoHeight
                onRowClick={(data) => {
                  console.log(data)
                }}
              >
                <Column width={100} flexGrow={1} colSpan={2}>
                  <HeaderCell align="center">หัวข้อ</HeaderCell>
                  {/* <Cell dataKey="topic" /> */}
                  <Cell>
                    {(rowData) => {
                      if (rowData.text) {
                        return (
                          <span>
                            <b>{rowData.name}</b>
                          </span>
                        )
                      } else if (!rowData.main) {
                        return <span style={{ marginLeft: 10 }}>{rowData.name}</span>
                      } else return <span>{rowData.name}</span>
                    }}
                  </Cell>
                </Column>

                <Column width={160} align="center">
                  <HeaderCell>จำนวนคน</HeaderCell>
                  <Cell dataKey="value" />
                </Column>
              </Table>
              <p>
                ( {schema.elderlyHealthSourceInfo.label}{' '}
                <b>{schema.elderlyHealthSourceInfo.value}</b>
                {schema.elderlyHealthSourceMonth.label}{' '}
                <b>
                  {schema.elderlyHealthSourceMonth.options.map((item) => {
                    if (item.value == schema.elderlyHealthSourceMonth.value) {
                      return item.label
                    }
                  })}
                </b>{' '}
                {schema.elderlyHealthSourceInfoYear.label}{' '}
                <b>{schema.elderlyHealthSourceInfoYear.value}</b> )
              </p>
            </Col>
          </Row>

          <Row>
            <Col style={{ marginTop: 10 }}>
              <b>{schema.elderlySocialInfoText}</b>
              <Table
                style={{ marginTop: 10 }}
                bordered
                data={elderlySocialList}
                cellBordered
                autoHeight
                onRowClick={(data) => {
                  console.log(data)
                }}
              >
                <Column width={100} flexGrow={1} colSpan={2}>
                  <HeaderCell align="center">หัวข้อ</HeaderCell>
                  {/* <Cell dataKey="topic" /> */}
                  <Cell>
                    {(rowData) => {
                      if (rowData.text) {
                        return (
                          <span>
                            <b>{rowData.name}</b>
                          </span>
                        )
                      } else return <span>{rowData.name}</span>
                    }}
                  </Cell>
                </Column>

                <Column width={160} align="center">
                  <HeaderCell>จำนวนคน</HeaderCell>
                  <Cell dataKey="value" />
                </Column>
              </Table>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col>
              <p>
                &nbsp; &nbsp;&nbsp; &nbsp;{schema.elderlySocialInfoSummaray.preLabel}
                &nbsp; &nbsp;{schema.elderlySocialJoinActivity.value}
                &nbsp; &nbsp; {schema.elderlySocialInfoSummaray.postLabel}
                &nbsp; &nbsp; {schema.elderlySocialInfoPercent.preLabel}
                &nbsp; &nbsp;
                {schema.elderlySocialJoinActivity.value
                  ? (
                      (schema.elderlySocialJoinActivity.value * 100) /
                      schema.elderlySocialCount.value
                    ).toFixed(2)
                  : '00.00'}
                &nbsp; &nbsp;{schema.elderlySocialInfoPercent.postLabel}
              </p>
            </Col>
            <Col>
              {schema.elderlySocialInfoFooter.value ? (
                <div dangerouslySetInnerHTML={{ __html: schema.elderlySocialInfoFooter.value }} />
              ) : (
                <div>
                  <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
                  <Graph height={9} />
                  <Graph height={9} />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col style={{ marginLeft: 20 }}>
              <p>{schema.otherProblems.label}</p>
            </Col>
            <Col>
              {schema.otherProblems.value ? (
                <div dangerouslySetInnerHTML={{ __html: schema.otherProblems.value }} />
              ) : (
                <div>
                  <Graph height={9} width={'95%'} style={{ marginLeft: 10 }} />
                  <Graph height={9} />
                  <Graph height={9} />
                </div>
              )}
            </Col>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}

const styles = {
  personstyles: {
    width: 90,
    marginBottom: 5,
  },
  detailstyles: {
    width: 90,
  },
  rowStyles: {
    marginLeft: 20,
  },
  percentStyles: {
    width: 70,
    marginBottom: 5,
  },
  percentDetailStyles: {
    width: 70,
  },
  preLabelStyle: {
    width: '220px',
    textAlign: 'left',
  },
  leftWidth110: {
    width: '110px',
    textAlign: 'left',
  },
  marginTop10: {
    marginTop: 10,
  },
  marginTop_2em: {
    marginTop: 20,
  },
  dataStyles: { marginLeft: 10 },
}
